if (!customElements.get('fg-heximage')) {
  customElements.define('fg-heximage', class extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('video');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const play = () => {
        if (!video.getAttribute('src')) video.src = video.dataset.src;
        video.muted = true;
        video.play().catch(() => {});
      };
      const sync = () => { if (motion.matches) video.pause(); else play(); };
      motion.addEventListener('change', sync);
      this.cleanupMotion = () => motion.removeEventListener('change', sync);
      sync();
    }
    disconnectedCallback() { this.querySelector('video')?.pause(); this.cleanupMotion?.(); }
  });
}
